// extracted by mini-css-extract-plugin
export default {"card_modal":"editor_card_modal__BfK0I","card_body":"editor_card_body__DuTMF"};